import { Button, Label, Radio } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { QueryState } from 'react-query/types/core/query';
import { useToast } from 'src/context/ToastProvider';
import { GetCampusHiringApplicationsWithCandidatesAPIResponse } from 'types';
import UsersAvatarGroup from './UsersAvatarGroup';
import CampusInviteJobSeekerForDrive from '../campus/campusCandidateListing/campusInterviewComponents/CampusInviteJobSeekerForDrive';
import { useSearchParams } from 'react-router-dom';

const CampusUserBulkAction = ({
	onFinish,
	defaultBulkAction,
	bulkSelectedCandidates,
}: {
	onFinish?: () => void;
	bulkSelectedCandidates: string[];
	defaultBulkAction?: string | null;
}) => {
	const queryClient = useQueryClient();
	const [searchParams, setSearchParams] = useSearchParams();
	const queryKeys = queryClient.getQueryCache().findAll(['getCampusHiringApplicationsWithCandidates']);
	const allData: GetCampusHiringApplicationsWithCandidatesAPIResponse[] = queryKeys
		.map(key => queryClient.getQueryData<GetCampusHiringApplicationsWithCandidatesAPIResponse>(key.queryKey))
		.filter(data => data !== undefined) as GetCampusHiringApplicationsWithCandidatesAPIResponse[];

	const combinedData = allData.flatMap(data => data.campusHiringApplications || []);

	const selectUser = combinedData.filter(e => bulkSelectedCandidates.includes(e?._id));

	const [localActionSelect, setLocalActionSelect] = useState('');
	const [selectedBulkAction, setSelectedBulkAction] = React.useState<string>(defaultBulkAction as string);

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setSelectedBulkAction(localActionSelect);
	};

	const getBulkActionContent = (data: string) => {
		switch (data) {
			case 'invite-for-placement-drive': {
				return (
					<div>
						<CampusInviteJobSeekerForDrive
							jobseekers={selectUser}
							onFinish={() => {
								onFinish && onFinish();
							}}
						/>
					</div>
				);
			}
			default: {
				return (
					<form onSubmit={handleSubmit}>
						<fieldset
							className="grid grid-cols-1 max-w-md gap-4"
							onChange={e => {
								const target = e.target as HTMLInputElement;
								if (target?.value) {
									setLocalActionSelect(target?.value);
								}
							}}
						>
							<div className="flex items-center gap-2">
								<Radio
									className="text-[#7777E7] focus:ring-[#7777E7]"
									id={'inviteForPlacementDrive'}
									name="bulkAction"
									value={'invite-for-placement-drive'}
									checked={localActionSelect === 'invite-for-placement-drive'}
								/>
								<Label htmlFor={'inviteForPlacementDrive'} className="text-sm font-[400] font-inter">
									Invite For Placement Drive
								</Label>
							</div>
						</fieldset>
						<Button
							disabled={!localActionSelect}
							type="submit"
							color="purplePlaced"
							className="bg-[#7777E7] w-full mt-[24px]"
						>
							{localActionSelect === 'reject-candidates'
								? 'Reject Candidates'
								: localActionSelect === 'hire-candidates'
								  ? 'Hire Candidates'
								  : 'Select'}
						</Button>
					</form>
				);
			}
		}
	};

	return (
		<>
			<div className="px-3 py-4">
				<UsersAvatarGroup
					candidates={
						selectUser?.map(e => ({
							name: e?.name || '',
							profileImageUrl: e?.profile?.profileImageUrl || e?.profile?.imageUrl || '',
						})) || []
					}
				/>

				<div className="h-[1px] bg-[#EBEBF0] my-[12px]"></div>
			</div>

			<div className="px-3 pb-4">{getBulkActionContent(selectedBulkAction as string)}</div>
		</>
	);
};

export default CampusUserBulkAction;
